module.exports = __webpack_public_path__ + "img/woman2a.ceb2c7ee.png";